<lucide-icon
  *ngIf="lucideName; else fontIcon"
  [name]="lucideName"
  [ngClass]="extraClass"
  class="popup-menu-item__icon"
  [size]="18"
  aria-hidden="true"
></lucide-icon>
<ng-template #fontIcon>
  <span class="popup-menu-item__icon" [ngClass]="iconName"></span>
</ng-template>
<ng-content></ng-content>
